import { JSONWidgetType as TeaserStandardVerticalVideoJSONWidgetType } from '@widgets/TeaserStandardVerticalVideo'

import {
  ExecuteQuery,
  getAureusBatchRecommendations,
  getSectionWithAureusEnvironment,
  Purpose,
  QueryFactory,
} from '..'

interface AureusVideoCarouselItem extends Record<string, unknown> {
  aureusOfferId: string
  articleID: string
  teasers: {
    standardVerticalVideo: TeaserStandardVerticalVideoJSONWidgetType
  }
}

export const queryKey = 'polaris-viral-videos'

export const createQuery = (({
  sectionName,
  contentBlacklist,
  purpose,
}: {
  sectionName?: string
  contentBlacklist?: string
  purpose?: Purpose
}) =>
  ({
    [queryKey]: {
      resultsLimit: 12,
      context: {
        section: getSectionWithAureusEnvironment(
          `polaris-viral-videos${sectionName === 'sport' ? '-sport' : ''}`,
        ),
        purpose: purpose || 'reference',
        minHardness: 3,
        contentBlacklist,
      },
    },
  }) as const) satisfies QueryFactory<typeof queryKey>

export const executeQuery = (async (
  queryOptions: Parameters<typeof createQuery>[0],
  options?: Record<string, unknown>,
) => {
  try {
    const result = (
      await getAureusBatchRecommendations<
        typeof queryKey,
        AureusVideoCarouselItem
      >(createQuery(queryOptions), options)
    ).results[queryKey]

    if (!Array.isArray(result?.recommendations)) {
      return
    }

    return result.recommendations
  } catch (err) {
    console.error(err)
  }
}) satisfies ExecuteQuery<typeof queryKey>
